import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';

@Component({
    selector: 'app-time-configuration',
    templateUrl: './time-configuration.component.html',
    styleUrls: ['./time-configuration.component.css'],
})

export class TimeConfigurationComponent implements OnInit {
    hours: any;
    minutes: any;
    editing: boolean = false;
    attendTime: string;
    closeTime: string;

    TimeSelected: any = {
        attendTime: "",
        closeTime: ""
    }

    constructor(
        public functionsService: FunctionsService,
        private formBuilder: UntypedFormBuilder,
        private apiService: ApiService,
        public spinner: NgxSpinnerService) { 
            this.functionsService.setTitle('setting.time_configuration');
        }
        timeConfigurationForm = this.formBuilder.group({
            attendHours: new UntypedFormControl(''),
            attendMinutes: new UntypedFormControl(''),
            closeHours: new UntypedFormControl(''),
            closeMinutes: new UntypedFormControl('')
          });

    ngOnInit(){
        this.hours = AppConstants.hours;
        this.minutes = AppConstants.minutes;
        this.timeConfigurationForm.controls['attendHours'].disable();
        this.timeConfigurationForm.controls['attendMinutes'].disable();
        this.timeConfigurationForm.controls['closeHours'].disable();
        this.timeConfigurationForm.controls['closeMinutes'].disable();
        this.getTimeConfiguration();
    }

    getTimeConfiguration(){
        this.spinner.show();
        this.apiService.getTimeConfiguration().subscribe(
            data => {
                if(data["attendTime"] != ""){
                    this.attendTime = data["attendTime"].split(':');
                    this.timeConfigurationForm.controls['attendHours'].setValue(this.attendTime[0] == "00"? "" : this.attendTime[0]);
                    this.timeConfigurationForm.controls['attendMinutes'].setValue(this.attendTime[1] == "00"? "": this.attendTime[1]);
                }
                if(data["closeTime"] != ""){
                    this.attendTime = data["closeTime"].split(':');
                    this.timeConfigurationForm.controls['closeHours'].setValue(this.attendTime[0] == "00"? "": this.attendTime[0]);
                    this.timeConfigurationForm.controls['closeMinutes'].setValue(this.attendTime[1] == "00"? "": this.attendTime[1]);
                }
                this.spinner.hide();
            },
            error => {this.spinner.hide();}
        );
    }

    setTimeConfiguration(){
        this.spinner.show();
        var attendHours = this.timeConfigurationForm.get('attendHours').value == "" && this.timeConfigurationForm.get('attendMinutes').value != ""? "00": this.timeConfigurationForm.get('attendHours').value;
        var attendMinutes = this.timeConfigurationForm.get('attendHours').value != "" && this.timeConfigurationForm.get('attendMinutes').value == ""? "00": this.timeConfigurationForm.get('attendMinutes').value;
        var closeHours = this.timeConfigurationForm.get('closeHours').value == "" && this.timeConfigurationForm.get('closeMinutes').value != ""? "00": this.timeConfigurationForm.get('closeHours').value;
        var closeMinutes = this.timeConfigurationForm.get('closeHours').value != "" && this.timeConfigurationForm.get('closeMinutes').value == ""? "00": this.timeConfigurationForm.get('closeMinutes').value;
        this.TimeSelected.attendTime = attendHours + ':' + attendMinutes;
        this.TimeSelected.closeTime = closeHours + ':' + closeMinutes;
        this.apiService.setTimeConfiguration(this.TimeSelected).subscribe(
            data => {
                this.edit();
                this.getTimeConfiguration();
            },
            error => {this.spinner.hide();}
        );
    }

    edit(){
        this.editing = !this.editing;
        if(!this.editing){
            this.timeConfigurationForm.controls['attendHours'].disable();
            this.timeConfigurationForm.controls['attendMinutes'].disable();
            this.timeConfigurationForm.controls['closeHours'].disable();
            this.timeConfigurationForm.controls['closeMinutes'].disable();
            this.getTimeConfiguration();
        } else {
            this.timeConfigurationForm.controls['attendHours'].enable();
            this.timeConfigurationForm.controls['closeHours'].enable();
            if (this.timeConfigurationForm.controls['attendHours'].value == 24) {
                this.timeConfigurationForm.controls['attendMinutes'].disable();
            } else {
                this.timeConfigurationForm.controls['attendMinutes'].enable();
            }
            if (this.timeConfigurationForm.controls['closeHours'].value == 24) {
                this.timeConfigurationForm.controls['closeMinutes'].disable();
            } else {
                this.timeConfigurationForm.controls['closeMinutes'].enable();
            }            
        }
    }

    onChangeTimeToAttend(select) {
        if (select == 24) {
            this.timeConfigurationForm.controls['attendMinutes'].setValue("00");
            this.timeConfigurationForm.controls['attendMinutes'].disable();
        } else {
            this.timeConfigurationForm.controls['attendMinutes'].enable();
        }
    }
    onChangeTimeToClose(select) {
        if (select == 24) {
            this.timeConfigurationForm.controls['closeMinutes'].setValue("00");
            this.timeConfigurationForm.controls['closeMinutes'].disable();
            
        } else {
            this.timeConfigurationForm.controls['closeMinutes'].enable();
        }
    }
}